import { render, staticRenderFns } from "./myCalc.vue?vue&type=template&id=2fb0f6cd&"
import script from "./myCalc.vue?vue&type=script&lang=js&"
export * from "./myCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports